import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./styles/main.css";
import * as Sentry from "@sentry/react";
import { createRoot } from 'react-dom/client';
import './output.css';

import '@gravity-ui/uikit/styles/styles.css';

import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import UpdatesNotification from "./components/new_components/UpdatesNotification.js";
posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  person_profiles: "identified_only",
});

const env = process.env.REACT_APP_ENV_PROD || process.env.REACT_APP_ENV;

if (env === "staging" || env === "production") {
  Sentry.init({
    dsn: "https://db69a914ff75185cb2870a17454f3637@o4508006141001728.ingest.us.sentry.io/4508007924105216",
    environment: env,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      process.env.REACT_APP_SERVER_ENDPOINT,
      "https://gitex-staging.web.app/",
      "https://www.wubble.ai/",
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </React.StrictMode>,
  document.getElementById("root")
);


/** 
const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UpdatesNotification count={1} />
  </React.StrictMode>
);
*/